import firebase from '../../../config/firebase';

import uuid from 'uuid';

const database = firebase.database();

export function getChats (callback) {
  database.ref('chats').on('value', function (snapshot) {
    const chats = snapshot.val();
    callback(true, chats, null);
  })
}

// create new chat
export function createNewChat (data, callback) {
  const id = data._id;
  const uid = data.uid;
  let datum = data;
  datum.uid = null;
  database.ref('chats/' + uid + "/messages/" + id).set(datum, function(error) {
    if (error) {
        callback(false, null, error);
    } else {
        callback(true, data, null);
    }
  })
}

export function sendImageToChat (data, callback) {
  const file = data.image;
  console.log('F', file);
  const id = uuid.v4();
  const metadata = {
    contentType: file.type
  };
  firebase.storage()
    .ref('chats')
    .child(id)
    .put(file, metadata)
    .then((img) => {
      firebase.storage().ref('chats').child(id).getDownloadURL()
        .then((downloadURL) => {
          let datum = {};
          datum.key = null;
          datum.image = downloadURL;
          datum.messageType = 'image';
          datum.createdAt = Date.now();
          datum._id = data.index;
          datum.user = { _id: 2};
          database.ref('chats/' + data.key + "/messages/" + data.index).set(datum, function(error) {
            if (error) {
                callback(false, null, error);
            } else {
                callback(true, data, null);
            }
          })
        })
    })
    .catch(e => {
      alert(e)
    });
}

// update read/unread status, who's assigned.
export function updateChatMetadata (data, callback) {
  database.ref('chats/' + data.key).update(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}

// sendImageToChat
// updateChatMetadata

// TODO: create Set Chat Metadata function
